/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Start_AriaInputs */



/**
* | output |
* | --- |
* | "Start batch export" |
*
* @param {Batch_Subtitle_Export_Start_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_start_aria = /** @type {((inputs?: Batch_Subtitle_Export_Start_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Start_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrer l’exportation par lot")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stapelexport starten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvia l'esportazione in batch")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начать пакетный экспорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar exportación por lotes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始批量导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一括エクスポートを開始")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच निर्यात शुरू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciar exportação em lote")
	return /** @type {LocalizedString} */ ("Start batch export")
});